import React from 'react'
import Instagram from '@material-ui/icons/Instagram'
import PropTypes from 'prop-types'

const InstagramIcon = ({ height, width, ...props }) => {

    return (
        <Instagram
            height={height}
            width={width}
            {...props}
        />
    )
}

InstagramIcon.propTypes = {
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
}

export default InstagramIcon